import React, { useState, useEffect, useCallback, useRef } from "react";
import ReactPaginate from "react-paginate";
import { useLocation, useNavigate } from "react-router-dom";
import { deletePosts, fetchUserPosts } from "../../utils/PostComponents";
import { truncateDescription } from "../../utils/truncateDescritopn";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DialogBox from "../OtherComponents/DialogBox";
import FilterBar from "../../utils/FilterUi";

const Base_Url = process.env.REACT_APP_BASE_URL;

const UserPosts = ({ view = "myProfile" }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [postToDelete, setPostToDelete] = useState([]);
  const topRef = useRef(null);
  const queryParams = new URLSearchParams(location.search);
  const initialPage = parseInt(queryParams.get("page")) || 1;

  const [page, setPage] = useState(initialPage);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(5);

  const [filters, setFilters] = useState({
    status: "",
    sort: "",
    search: "",
  });
  const [activeFilters, setActiveFilters] = useState({
    status: "",
    sort: "",
    search: "",
  });

  const updateUrlParams = useCallback(
    async (newPage, newLimit) => {
      const searchParams = new URLSearchParams(location.search);
      searchParams.set("page", newPage);
      searchParams.set("limit", newLimit);
      searchParams.set("search", filters.search);
      searchParams.set("status", filters.status);
      searchParams.set("sort", filters.sort);
      navigate({ search: searchParams.toString() });
    },
    [location.search, navigate, filters]
  );

  useEffect(() => {
    if (
      Object.values(activeFilters).some((filter) => filter) &&
      topRef.current
    ) {
      setTimeout(() => {
        topRef.current.scrollIntoView({ behavior: "auto", block: "start" });
      }, 500);
    }
  }, [activeFilters]);

  const fetchData = useCallback(async () => {
    const data = await fetchUserPosts(
      setPosts,
      setTotalPages,
      filters,
      page,
      limit
    );
    let newPage = data.totalPosts > page ? page : 1;
    setPage(newPage);
    await updateUrlParams(newPage, limit);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, [filters, limit, page, updateUrlParams]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleDonate = (post) => {
    navigate(`/view/post/${post._id}`);
  };

  const handleDelete = async () => {
    const res = await deletePosts(postToDelete);
    if (res) {
      toast.success(res.data.msg);
    } else {
      toast.err(res.data.msg);
    }
    setOpen(false);
    fetchUserPosts(setPosts, setTotalPages, filters, page, limit);
  };

  const handlePageChange = async (selectedPage) => {
    const newPage = selectedPage.selected + 1; // ReactPaginate uses 0-based indexing
    setPage(newPage);
    await updateUrlParams(newPage, limit);
  };

  const handleLimitChange = async (e) => {
    const newLimit = parseInt(e.target.value);
    setLimit(newLimit);
    setPage(1);
    await updateUrlParams(1, newLimit);
  };

  return (
    <>
      <div className={view !== "profile" ? "aligned-container" : ""}>
        <div className="custom_container">
          <div className="top_desc">
            <ToastContainer />
            <div className="heading_btn">
              <h2 className="heading">My Posts</h2>

              <div className="add-post-div">
                <button
                  className="open-modal-btn"
                  onClick={() => {
                    navigate("/add/post");
                  }}
                >
                  Add Post
                </button>
              </div>
            </div>
            <div ref={topRef}>
              <FilterBar
                filters={filters}
                setFilters={setFilters}
                activeFilters={activeFilters}
                setActiveFilters={setActiveFilters}
              />
            </div>
          </div>
          {loading && (
            <div className="container loading-dots">
              <span>.</span>
              <span>.</span>
              <span>.</span>
            </div>
          )}

          {!loading &&
            (posts && posts.length > 0 ? (
              <div className="post-container">
                {posts.map((post) => (
                  <div className="post-card" key={post._id}>
                    <div className="badge-div">
                      {Number(post.paidAmount) === Number(post.amount) && (
                        <span className="fully-paid-badge">Fully Paid</span>
                      )}
                      {Number(post.paidAmount) < Number(post.amount) && (
                        <span className="partially-paid-badge">
                          Partially Paid
                        </span>
                      )}
                    </div>
                    <div className="card-image">
                      <img
                        src={`${Base_Url}/assets/postThumbnails/${post.attachment}`}
                        alt="Post Img"
                      />
                    </div>
                    <div className="card-content">
                      <h3 className="post-title">{post.title}</h3>
                      <p className="amount">${post.amount}</p>
                      <p
                        className="description"
                        dangerouslySetInnerHTML={{
                          __html: truncateDescription(post.description, 30),
                        }}
                      ></p>
                      <div className="card-actions">
                        <button
                          className="donate-btn"
                          onClick={() => {
                            handleDonate(post);
                          }}
                        >
                          View
                        </button>
                        <button
                          className="donate-btn"
                          onClick={() => {
                            navigate(`/edit/post/${post._id}`, {
                              state: { isEditing: true, post: post },
                            });
                          }}
                        >
                          Edit
                        </button>
                        <button
                          className="donate-btn"
                          onClick={() => {
                            setOpen(true);
                            setPostToDelete(post);
                          }}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="post-container">No Posts Found</div>
            ))}

          {!loading && (
            <div className="blog-paginate">
              <div className="limit-selection">
                <label htmlFor="limit">Posts per page: </label>
                <select id="limit" value={limit} onChange={handleLimitChange}>
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={35}>35</option>
                  <option value={50}>50</option>
                </select>
              </div>
              {posts && posts.length > 0 && totalPages && totalPages > 1 && (
                <ReactPaginate
                  pageCount={totalPages}
                  onPageChange={handlePageChange}
                  containerClassName="pagination"
                  previousLabel={"<"}
                  nextLabel={">"}
                  breakLabel={"..."}
                  marginPagesDisplayed={1}
                  pageRangeDisplayed={2}
                  pageClassName={"page-item"}
                  activeClassName={"active"}
                  forcePage={page - 1} // Sync with current page
                />
              )}
            </div>
          )}
          {open && (
            <DialogBox
              open={open}
              handleClose={handleClose}
              handleAction={handleDelete}
              action={postToDelete}
              item={"post"}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default UserPosts;
